import { render, staticRenderFns } from "./ProductoEdicionMasivaAtributosModal.vue?vue&type=template&id=10b964f8&"
import script from "./ProductoEdicionMasivaAtributosModal.vue?vue&type=script&lang=js&"
export * from "./ProductoEdicionMasivaAtributosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports